import { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import Dialogo from './ui/Dialogo';
import { btnPrimario, btnSecundario, campo } from './ui/estilos';

interface Props {
  permiso: string;
  titulo: string;
  descripcion?: string;
  onSuccess: (usuario: { id: string; nombre: string }, password: string) => void;
  onCancel: () => void;
}

export default function ModalLlaveAcceso({ permiso, titulo, descripcion, onSuccess, onCancel }: Props) {
  const [pass, setPass]       = useState('');
  const [error, setError]     = useState('');
  const [cargando, setCargando] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 80);
  }, []);

  const verificar = async () => {
    if (!pass) { setError('Ingresa la contraseña'); return; }
    setCargando(true); setError('');
    try {
      const res = await api.post('/configuracion/verificar-acceso', { password: pass, permiso });
      onSuccess(res.data.usuario, pass);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Error al verificar');
      setPass('');
      inputRef.current?.focus();
    } finally {
      setCargando(false);
    }
  };

  return (
    <Dialogo titulo={titulo} onCerrar={onCancel} ancho={420}>
      {descripcion && <p style={{ margin: 0, fontSize: 16, color: 'var(--muted)', lineHeight: 1.4 }}>{descripcion}</p>}
      <label htmlFor="llave-pass" style={{ fontSize: 15, fontWeight: 700, color: 'var(--muted)' }}>Contraseña de quien autoriza</label>
      <input
        id="llave-pass" ref={inputRef} type="password" autoComplete="off" placeholder="Contraseña"
        value={pass} onChange={e => { setPass(e.target.value); setError(''); }}
        onKeyDown={e => e.key === 'Enter' && !cargando && verificar()}
        style={{ ...campo, fontSize: 18, letterSpacing: '.1em' }}
      />
      {error && <div role="alert" style={{ fontSize: 15, color: 'var(--danger)', fontWeight: 700 }}>{error}</div>}
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onCancel} style={{ ...btnSecundario, flex: 1, height: 52 }}>Cancelar</button>
        <button onClick={verificar} disabled={cargando || !pass}
          style={{ ...btnPrimario, flex: 2, height: 52, fontSize: 16, opacity: cargando || !pass ? .5 : 1 }}>
          {cargando ? 'Verificando…' : 'Autorizar'}
        </button>
      </div>
    </Dialogo>
  );
}
